import type {ReactAction} from '@netx/core/bootstrap';
import {faCalendar} from '@netx/core-icons';
import {canManageCurrentCartExpiration} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';
import {cartActionManageExpirationSet} from './cart-manage-expiration-set';
import {cartActionManageExpirationUnset} from './cart-manage-expiration-unset';

/**
 * Manage cart asset expiration
 * @param params
 * @returns Action
 */
export const cartActionManageExpiration = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-expiration',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.MANAGE_EXPIRATION),
	enableTest: canManageCurrentCartExpiration,
	icon: faCalendar,
	get label() {
		return CART_CURRENT_ACTION_LABELS.MANAGE_EXPIRATION;
	},
	children: [
		cartActionManageExpirationSet(),
		cartActionManageExpirationUnset(),
	],
	...params,
});

export default cartActionManageExpiration;
